import { groupBy, shuffleArray, API_URL } from '../../config';
import axios from '../../axios';

const state = {
  isLoading: false,
  allSponsors: null,
  goldJobs: [],
  silverAndBronzeJobs: [],
  eventsForSchedule: [],
  eventDistinctDays: [],
};

const getters = {
  sponsor: state => state.allSponsors,
  silverAndBronzeJobs: state => state.silverAndBronzeJobs,
  goldJobs: state => state.goldJobs,
  events: state => state.eventsForSchedule,
  eventDistinctDays: state => state.eventDistinctDays,
  isLoading: state => state.isLoading,
};

const actions = {
  getLanding({ commit }) {
    commit('setLoading', true);
    axios
      .get(`${API_URL}/landing`)
      .then(response => {
        commit('setAllSponsorsAndJobs', response.data.allSponsors);
        commit('setEventsForSchedule', response.data.eventsForSchedule);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setAllSponsorsAndJobs(state, allSponsors) {
    state.allSponsors = groupBy(
      allSponsors.sort((firstSponsor, secondSponsor) =>
        firstSponsor.name.toLowerCase() < secondSponsor.name.toLowerCase() ? -1 : 1,
      ),
      'sponsorCategory',
    );

    const silverAndBronzeJobArray = [];
    const goldJobArray = [];

    if (state.allSponsors.hasOwnProperty('Gold'))
      state.allSponsors.Gold.forEach(sponsor => {
        goldJobArray.push(...sponsor.jobs);
      });

    if (state.allSponsors.hasOwnProperty('Bronze'))
      state.allSponsors.Bronze.forEach(sponsor => {
        silverAndBronzeJobArray.push(...sponsor.jobs);
      });

    if (state.allSponsors.hasOwnProperty('Silver'))
      state.allSponsors.Silver.forEach(sponsor => {
        silverAndBronzeJobArray.push(...sponsor.jobs);
      });

    shuffleArray(silverAndBronzeJobArray);
    shuffleArray(goldJobArray);
    state.silverAndBronzeJobs = silverAndBronzeJobArray;
    state.goldJobs = goldJobArray;
  },
  setEventsForSchedule(state, eventsForSchedule) {
    state.eventDistinctDays = [...new Set(eventsForSchedule.map(event => new Date(event.starts).getDate()))].sort();

    state.eventsForSchedule = groupBy(eventsForSchedule, 'type');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
